var _circle, _text, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 50,
    cy: 58,
    r: 33.25
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 32.7539 77.2109)",
    display: "none",
    enableBackground: "new    ",
    fontFamily: "'MyriadPro-Regular'",
    fontSize: 79.1576
  }, "P")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M37.684,60.26v20.566 M37.684,60.232v0.027 M37.684,35.174v25.058 M37.684,58.859h12.09c6.927,0,12.543-4.914,12.543-11.843 c0-6.927-5.616-11.842-12.543-11.842h-12.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark2);
export default __webpack_public_path__ + "static/media/park2.c796250bf403722b6b6a594389676ded.svg";
export { ForwardRef as ReactComponent };